export const colors = [
  "#3290d0", "#3190cf", "#3190ce", "#3190cd", "#3090cb", "#2f90ca", "#2f90c8", "#2e90c6", 
  "#2d91c4", "#2c91c1", "#2c91bf", "#2b91bd", "#2a92ba", "#2992b7", "#2892b4", "#2792b1", 
  "#2693ae", "#2493ab", "#2393a8", "#2294a5", "#2194a1", "#20949e", "#1e959a", "#1d9596", 
  "#1c9693", "#1a968f", "#19968b", "#179787", "#169783", "#15987d"
];

export const REGISTRATION_SIDEBAR_SELECTOR = {
  propertyRegistration: "property-registration",
  meterRegistration: "meter-registration",
  clientRegistration: "client-registration",
};

export const DESIGNATIONS = {
  admin: "admin",
  client: "client",
};

export const PAGE_TABS_ACCESSORS = {
  meter: {
    label: "Meter",
    value: "meter",
  },
  billing: {
    label: "Billing",
    value: "billing",
  },
  errorCodes: {
    label: "Error Codes",
    value: "error_codes",
  },
};

export const ROLES = {
  ADMIN: "admin",
};

export const METER_SIDEBAR_SELECTOR = {
  meterDetails: "meter-details",
  meterPayloadDetails: "meter-payload-details",
  meterOverview: "meter-overview",
  meterShare: "meter-share",
} as const;
